import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/AuthContext";
import { clearSignupSource } from "../lib/signupSource";

// Handles return from Google OAuth.
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const query = new URLSearchParams(window.location.search);
    const fragment = new URLSearchParams((window.location.hash || "").replace(/^#/, ""));
    const token = query.get("token") || fragment.get("token");
    const error = query.get("error") || fragment.get("error");

    (async () => {
      try {
        if (!token || error) {
          navigate("/login?error=oauth", { replace: true });
          return;
        }
        localStorage.setItem("gumi_token", token);
        clearSignupSource();
        const r = await api.get("/auth/me");
        setUser(r.data);
        window.history.replaceState(null, "", window.location.pathname);
        // No "is this a new signup" flag comes back from the OAuth redirect
        // itself, so this is a heuristic: an account created moments ago is
        // almost certainly the one that was just created by this callback,
        // not a returning user's stale account.
        const justRegistered = r.data.created_at
          ? Date.now() - new Date(r.data.created_at).getTime() < 30000
          : false;
        navigate(r.data.active_profile_id ? "/dashboard" : "/profile/resume", {
          replace: true,
          state: { user: r.data, justRegistered },
        });
      } catch (e) {
        localStorage.removeItem("gumi_token");
        navigate("/login?error=oauth", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-canvas flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="mx-auto h-10 w-10 rounded-full border-2 border-navy/15 border-t-navy animate-spin" />
        <p className="mt-6 font-body text-sm text-ink-soft">Signing you in…</p>
      </div>
    </div>
  );
}
